export const ERROR_CODE_40001 = 40001;
export const ERROR_CODE_40002 = 40002;
export const ERROR_CODE_40003 = 40003;
export const ERROR_CODE_40004 = 40004;
